module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapNumber2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdr2"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_07_ack"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_09_int"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_09_int"
    }
  }, [_vm._v("Afterthoughts on His Afterlives")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_10_pt01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_10_pt01"
    }
  }, [_c('strong', [_c('em', [_vm._v("If the Mantle Fits")]), _vm._v(" . . .")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_11_cha01"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_11_cha01"
    }
  }, [_vm._v("Virtuous Men? or “The American Orwell” (I)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_12_cha02"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292734746_12_cha02"
    }
  }, [_vm._v("“Dear Dwight,” or “The American Orwell” (II)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_13_cha03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_13_cha03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“St. Irving”? or “The American Orwell” (III)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_14_cha04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_14_cha04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fellow Contrarians? or “The (Anglo-)American Orwell” (IV)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_15_cha05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_15_cha05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“True Patriot and Traditionalist,” or “The (Hungarian-)American Orwell” (V)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_16_pt02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_16_pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Politics and the German Language")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_17_cha06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_17_cha06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The (Un-rosy) State of Orwellian Unlearning")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_18_cha07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_18_cha07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books That Led to Miniluv")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_19_cha08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_19_cha08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 + 2 = 5?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_20_cha09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 9")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_20_cha09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Behind the Wall, or How the Eurasian "), _c('em', [_vm._v("Reich")]), _vm._v(" Viewed Oceania")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_21_cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 10")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_21_cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revenge of the Thought Police")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_22_pt03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_22_pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Un")]), _vm._v("("), _c('em', [_vm._v("der")]), _vm._v(")"), _c('em', [_vm._v("examined Orwell")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_23_cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 11")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_23_cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Did Papa Rescue St. George?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_24_cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 12")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_24_cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Rock (Sugar)candy Mountain?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_25_cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 13")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_25_cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literacy and the English Language")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_26_cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 14")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_26_cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Orwell, Literary Theorist?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_27_cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 15")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_27_cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Architectonics of Room")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_28_cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 16")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_28_cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Review Orwell Never Wrote?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_29_cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 17")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_29_cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Life Orwell Never Lived?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_30_cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 18")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_30_cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Centenarian, Our Contemporary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_31_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUSION")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_31_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If He Had Lived . . .")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr1"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_32_not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl1a"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292734746_33_ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a799466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292734746_06_toc.vue
// module id = 75
// module chunks = 0